module.exports = __webpack_public_path__ + "img/off-badge.648d05b2.png";